<div style="margin: 5px" class="clearfix">
  <div style="float: left; margin-bottom: 5px">
    <span style="font-weight: 500; font-size: 1.4em">{{ data.areaTitle }}</span>
    <span
      *ngIf="!data.isSignature && data.conditionTitle"
      style="color: lightgrey; margin-left: 5px"
    >
      {{ data.conditionTitle }}
    </span>
    <span *ngIf="data.conditionComment" style="color: lightgrey; margin-left: 5px">
      {{ data.conditionComment }}
    </span>
  </div>
  <div style="float: right">
    <span style="color: lightgrey; font-size: 0.8em">{{
      data.dateTime | date : 'EEE dd MMM HH:mm'
    }}</span>
  </div>
</div>
<div *ngIf="data.description" style="font-size: 0.9em; line-height: 1; margin: 5px 5px 10px 5px">
  {{ data.description }}
</div>
